import * as validators from "./validators";
const map = {
    // Personal Information
    FirstName: (field) => validators.validateName(field.value),
    LastName: (field) => validators.validateName(field.value),
    Email: (field) => validators.validateEmailAddress(field.value),
    EmailVerify: (field) => validators.valuesMatch(field.value, field.form.Email.value),
    DateOfBirth: (field) => validators.isValidDate(field.value),
    TaxID: (field) => validators.validateTaxId(field.value, field.form.getAttribute("data-staging") === "true"),
    TaxIDVerify: (field) => validators.valuesMatch(field.value, field.form.TaxID.value),
    // Address Information
    StreetAddress1: (field) => validators.hasAtLeastOneLetter(field.value),
    StreetAddress2: (field) => validators.hasAtLeastOneLetter(field.value),
    City: (field) => validators.validateCity(field.value),
    PrevStreetAddress1: (field) => validators.hasAtLeastOneLetter(field.value),
    PrevStreetAddress2: (field) => validators.hasAtLeastOneLetter(field.value),
    PrevCity: (field) => validators.validateCity(field.value),
    // Employment Information
    EmployerName: (field) => validators.hasAtLeastOneLetter(field.value),
    JobTitle: (field) => validators.hasAtLeastOneLetter(field.value),
    EmployerPhoneNumber: (field) => validators.validatePhoneNumber(field.value),
    Income: (field) => validators.isGreaterThan(Number(field.value)),
    // Previous Employment Information
    PrevEmployerName: (field) => validators.hasAtLeastOneLetter(field.value),
    PrevJobTitle: (field) => validators.hasAtLeastOneLetter(field.value),
    PrevEmployerPhoneNumber: (field) => validators.validatePhoneNumber(field.value),
    // Co-App
    CoAppFirstName: (field) => validators.validateName(field.value),
    CoAppLastName: (field) => validators.validateName(field.value),
    CoAppEmail: (field) => validators.validateEmailAddress(field.value),
    CoAppEmailVerify: (field) => validators.valuesMatch(field.value, field.form.CoAppEmail.value),
    CoAppTaxID: (field) => validators.validateTaxId(field.value, field.form.getAttribute("data-staging") === "true"),
    CoAppTaxIDVerify: (field) => validators.valuesMatch(field.value, field.form.CoAppTaxID.value),
    CoAppStreetAddress1: (field) => validators.hasAtLeastOneLetter(field.value),
    CoAppStreetAddress2: (field) => validators.hasAtLeastOneLetter(field.value),
    CoAppCity: (field) => validators.validateCity(field.value),
    CoAppPrevStreetAddress1: (field) => validators.hasAtLeastOneLetter(field.value),
    CoAppPrevStreetAddress2: (field) => validators.hasAtLeastOneLetter(field.value),
    CoAppPrevCity: (field) => validators.validateCity(field.value),
    CoAppEmployerName: (field) => validators.hasAtLeastOneLetter(field.value),
    CoAppJobTitle: (field) => validators.hasAtLeastOneLetter(field.value),
    CoAppEmployerPhoneNumber: (field) => validators.validatePhoneNumber(field.value),
    CoAppPrevEmployerName: (field) => validators.hasAtLeastOneLetter(field.value),
    CoAppPrevJobTitle: (field) => validators.hasAtLeastOneLetter(field.value),
    CoAppPrevEmployerPhoneNumber: (field) => validators.validatePhoneNumber(field.value),
};
export default map;
